import React, { createContext, useContext, useState, useEffect } from 'react';

interface AuthContextType {
  id_user: string | null;
  token: string | null;
  email: string | null;
  setAuthData: (id_user: string, token: string, email: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>({
  id_user: null,
  token: null,
  email: null,
  setAuthData: () => {},
  logout: () => {},
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [id_user, setIdUser] = useState<string | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [email, setEmail] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedId = localStorage.getItem('id_user');
    const storedToken = localStorage.getItem('token');
    const storedEmail = localStorage.getItem('email');
    if (storedId && storedToken && storedEmail) {
      setIdUser(storedId);
      setToken(storedToken);
      setEmail(storedEmail);
    }
    setLoading(false);
  }, []);

  const setAuthData = (id_user: string, token: string, email: string) => {
    if (!id_user || !token || !email) {
      console.error('Dados de autenticação inválidos fornecidos');
      return;
    }
    setIdUser(id_user);
    setToken(token);
    setEmail(email);
    localStorage.setItem('id_user', id_user);
    localStorage.setItem('token', token);
    localStorage.setItem('email', email);
  };

  const logout = () => {
    setIdUser(null);
    setToken(null);
    setEmail(null);
    localStorage.removeItem('id_user');
    localStorage.removeItem('token');
    localStorage.removeItem('email');
  };

  if (loading) {
    return <div>Carregando sessão...</div>;
  }

  return (
    <AuthContext.Provider value={{ id_user, token, email, setAuthData, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};